'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const slugify = (text) => {
  return text.toLowerCase().replace(/[^a-z0-9\u0430-\u044f]+/g, "-").replace(/^-+|-+$/g, "");
};
class FAQsCategories {
  get(params) {
    return transport.transport.request("faqsCategories/get", params).then((categories) => categories.map((category) => __spreadValues({
      slug: slugify(category.title || "")
    }, category)));
  }
}

exports.FAQsCategories = FAQsCategories;
